module.exports = {
	"imunidade": [
		{
			"code": "001",
			"description": "Livros, jornais, periódicos e o papel destinado à sua impressão"
		},
		{
			"code": "002",
			"description": "Produtos industrializados destinados ao exterior"
		},
		{
			"code": "003",
			"description": "Ouro, definido em lei como ativo financeiro ou instrumento cambial"
		},
		{
			"code": "004",
			"description": "Energia elétrica, derivados de petróleo, combustíveis e minerais do País"
		},
		{
			"code": "005",
			"description": "Exportação de produtos nacionais - sem saída do território brasileiro - venda para empresa sediada no exterior - atividades de pesquisa ou lavra de jazidas de petróleo e de gás natural"
		},
		{
			"code": "006",
			"description": "Exportação de produtos nacionais - sem saída do território brasileiro - venda para empresa sediada no exterior - incorporados a produto final exportado para o Brasil"
		},
		{
			"code": "007",
			"description": "Exportação de produtos nacionais - sem saída do território brasileiro - venda para órgão ou entidade de governo estrangeiro ou organismo internacional de que o Brasil seja membro,para ser entregue, no País, à ordem do comprador"
		}
	],
	"suspensao": [
		{
			"code": "101",
			"description": "Óleo de menta em bruto, produzido por lavradores"
		},
		{
			"code": "102",
			"description": "Produtos remetidos à exposição em feiras de amostras e promoções semelhantes"
		},
		{
			"code": "103",
			"description": "Produtos remetidos a depósitos fechados ou armazéns-gerais, bem assim aqueles devolvidos ao remetente"
		},
		{
			"code": "104",
			"description": "Produtos industrializados, que com matérias-primas (MP), produtos intermediários (PI) e material de embalagem (ME) importados submetidos a regime aduaneiro especial (drawback- suspensão/isenção), remetidos diretamente a empresas industriais exportadoras"
		},
		{
			"code": "105",
			"description": "Produtos, destinados à exportação, que saiam do estabelecimento industrial para empresas comerciais exportadoras, com o fim específico de exportação"
		},
		{
			"code": "106",
			"description": "Produtos, destinados à exportação, que saiam do estabelecimento industrial para recintos alfandegados onde se processe o despacho aduaneiro de exportação"
		},
		{
			"code": "107",
			"description": "Produtos, destinados à exportação, que saiam do estabelecimento industrial para outros locais onde se processe o despacho aduaneiro de exportação"
		},
		{
			"code": "108",
			"description": "Matérias-primas (MP), produtos intermediários (PI) e material de embalagem (ME) destinados ao executor de industrialização por encomenda"
		},
		{
			"code": "109",
			"description": "Produtos industrializados por encomenda remetidos ao estabelecimento de origem"
		},
		{
			"code": "110",
			"description": "Matérias-primas ou produtos intermediários remetidos para emprego em operação industrial realizada pelo remetente fora do estabelecimento"
		},
		{
			"code": "111",
			"description": "Veículo, aeronave ou embarcação destinados a emprego em provas de engenharia pelo fabricante"
		},
		{
			"code": "112",
			"description": "Produtos remetidos, para industrialização ou comércio, de um para outro estabelecimento da mesma firma"
		},
		{
			"code": "113",
			"description": "Bens do ativo permanente remetidos a outro estabelecim ento da mesma firma, para seremutilizados no processo industrial do recebedor"
		},
		{
			"code": "114",
			"description": "Bens do ativo permanente remetidos a outro estabelecimento, para serem utilizados no processo industrial de produtos encomendados pelo remetente"
		},
		{
			"code": "115",
			"description": "Partes e peças destinadas ao reparo de produtos com defeito de fabricação, quando a operação for executada gratuitamente, em virtude de garantia"
		},
		{
			"code": "116",
			"description": "Matérias-primas (MP), produtos intermediários (PI) e material de embalagem (ME) de fabricação nacional, vendidos a estabelecimento industrial, para industrialização de produtos destinados à exportação ou a estabelecimento comercial, para industrialização em outro estabelecimento da mesma firma ou de terceiro, de produto destinado à exportação"
		},
		{
			"code": "117",
			"description": "Produtos para emprego ou consumo na industrialização ou elaboração de produto a ser exportado, adquiridos no mercado interno ou importados"
		},
		{
			"code": "118",
			"description": "Bebidas alcoólicas e demais produtos de produção nacional acondicionados em recipientes de capacidade superior ao limite máximo permitido para venda a varejo"
		},
		{
			"code": "119",
			"description": "Produtos classificados NCM 21.06.90.10 Ex 02, 22.01, 22.02, exceto os Ex 01 e Ex 02 do Código 22.02.90.00 e 22.03 saídos de estabelecimento industrial destinado a comercial equiparado a industrial"
		},
		{
			"code": "120",
			"description": "Produtos classificados NCM 21.06.90.10 Ex 02, 22.01, 22.02, exceto os Ex 01 e Ex 02 do Código 22.02.90.00 e 22.03 saídos de estabelecimento comercial equiparado a industrial destinado a equiparado a industrial"
		},
		{
			"code": "121",
			"description": "Produtos classificados NCM 21.06.90.10 Ex 02, 22.01, 22.02, exceto os Ex 01 e Ex 02 do Código 22.02.90.00 e 22.03 saídos de importador destinado a equiparado a industrial"
		},
		{
			"code": "122",
			"description": "Matérias-primas (MP), produtos intermediários (PI) e material de embalagem (ME) destinados a estabelecimento que se dedique à elaboração de produtos classificados nos códigos previstos no art. 25 da Lei 10.684/2003"
		},
		{
			"code": "123",
			"description": "Matérias-primas (MP), produtos intermediários (PI) e material de embalagem (ME) adquiridos por estabelecimentos industriais fabricantes de partes e peças destinadas a estabelecimento industrial fabricante de produto classificado no Capítulo 88 da Tipi"
		},
		{
			"code": "124",
			"description": "Matérias-primas (MP), produtos intermediários (PI) e material de embalagem (ME) adquiridos por pessoas jurídicas preponderantemente exportadoras"
		},
		{
			"code": "125",
			"description": "Materiais e equipamentos destinados a embarcações pré-registradas ou registradas no Registro Especial Brasileira - REB quando adquiridos por estaleiros navais brasileiros"
		},
		{
			"code": "126",
			"description": "Aquisição por beneficiário de regime aduaneiro suspensivo do imposto, destinado a industrialização para exportação"
		},
		{
			"code": "127",
			"description": "Desembaraço de produtos de procedência estrangeira importados por lojas francas"
		},
		{
			"code": "128",
			"description": "Desembaraço de maquinas, equipamentos, veículos, aparelhos e instrumentos sem similar nacional importados por empresas nacionais de engenharia, destinados à execução de obras no exterior"
		},
		{
			"code": "129",
			"description": "Desembaraço de produtos de procedência estrangeira com saída de repartições aduaneiras com suspensão do Imposto de Importação"
		},
		{
			"code": "130",
			"description": "Desembaraço de matérias-primas, produtos intermediários e materiais de embalagem, importados diretamente por estabelecimento de que tratam os incisos I a III do caput do Decreto 7.212/2010"
		},
		{
			"code": "131",
			"description": "Remessa de produtos para a ZFM destinados ao seu consumo interno, utilização ou industrialização"
		},
		{
			"code": "132",
			"description": "Remessa de produtos para a ZFM destinados à exportação"
		},
		{
			"code": "133",
			"description": "Produtos que, antes de sua remessa à ZFM, forem enviados pelo seu fabricante a outro estabelecimento, para industrialização adicional, por conta e ordem do destinatário"
		},
		{
			"code": "134",
			"description": "Desembaraço de produtos de procedência estrangeira importados pela ZFM quando ali consumidos ou utilizados, exceto armas, munições, fumo, bebidas alcoólicas e automóveis de passageiros."
		},
		{
			"code": "135",
			"description": "Remessa de produtos para a Amazônia Ocidental destinados ao seu consumo interno ou utilização"
		},
		{
			"code": "136",
			"description": "Entrada de produtos estrangeiros na Área de Livre Comércio de Tabatinga - ALCT destinados ao seu consumo interno ou utilização"
		},
		{
			"code": "137",
			"description": "Entrada de produtos estrangeiros na Área de Livre Comércio de Guajará-Mirim - ALCGM destinados ao seu consumo interno ou utilização"
		},
		{
			"code": "138",
			"description": "Entrada de produtos estrangeiros nas Áreas de Livre Comércio de Boa Vista - ALCBV e Bomfim - ALCB destinados a seu consumo interno ou utilização"
		},
		{
			"code": "139",
			"description": "Entrada de produtos estrangeiros na Área de Livre Comércio de Macapá e Santana - ALCMS destinados a seu consumo interno ou utilização"
		},
		{
			"code": "140",
			"description": "Entrada de produtos estrangeiros nas Áreas de Livre Comércio de Brasiléia - ALCB e de Cruzeiro do Sul - ALCCS destinados a seu consumo interno ou utilização"
		},
		{
			"code": "141",
			"description": "Remessa para Zona de Processamento de Exportação - ZPE"
		},
		{
			"code": "142",
			"description": "Setor Automotivo - Desembaraço aduaneiro, chassis e outros - regime aduaneiro especial - industrialização 87.01 a 87.05"
		},
		{
			"code": "143",
			"description": "Setor Automotivo - Do estabelecimento industrial produtos 87.01 a 87.05 da TIPI - mercado interno - empresa comercial atacadista controlada por PJ encomendante do exterior."
		},
		{
			"code": "144",
			"description": "Setor Automotivo - Do estabelecimento industrial - chassis e outros classificados nas posições 84.29, 84.32, 84.33, 87.01 a 87.06 e 87.11 da TIPI."
		},
		{
			"code": "145",
			"description": "Setor Automotivo - Desembaraço aduaneiro, chassis e outros classificados nas posições 84.29, 84.32, 84.33, 87.01 a 87.06 e 87.11 da TIPI quando importados diretamente por estabelecimento industrial"
		},
		{
			"code": "146",
			"description": "Setor Automotivo - do estabelecimento industrial matérias-primas, os produtos intermediários e os materiais de embalagem, adquiridos por fabricantes, preponderantemente, decomponentes, chassis e outros classificados nos Códigos 84.29, 8432.40.00, 8432.80.00, 8433.20, 8433.30.00, 8433.40.00, 8433.5 e 87.01 a 87.06 da TIPI"
		},
		{
			"code": "147",
			"description": "Setor Automotivo - Desembaraço aduaneiro, as matérias-primas, os produtos intermediários e os materiais de embalagem, importados diretamente por fabricantes, preponderantemente,de componentes, chassis e outros classificados nos Códigos 84.29, 8432.40.00, 8432.80.00, 8433.20, 8433.30.00, 8433.40.00, 8433.5 e 87.01 a 87.06 da TIPI"
		},
		{
			"code": "148",
			"description": "Bens de Informática e Automação - matérias-primas, os produtos intermediários e os materiais de embalagem, quando adquiridos por estabelecimentos industriais fabricantes dos referidos bens."
		},
		{
			"code": "149",
			"description": "Reporto - Saída de Estabelecimento de máquinas e outros quando adquiridos por beneficiários do REPORTO"
		},
		{
			"code": "150",
			"description": "Reporto - Desembaraço aduaneiro de máquinas e outros quando adquiridos por beneficiários do REPORTO"
		},
		{
			"code": "151",
			"description": "Repes - Desembaraço aduaneiro - bens sem sim ilar nacional importados por beneficiários do REPES"
		},
		{
			"code": "152",
			"description": "Recine - Saída para beneficiário do regime"
		},
		{
			"code": "153",
			"description": "Recine - Desembaraço aduaneiro por beneficiário do regime"
		},
		{
			"code": "154",
			"description": "Reif- Saída para beneficiário do regime"
		},
		{
			"code": "155",
			"description": "Reif - Desembaraço aduaneiro por beneficiário do regime"
		},
		{
			"code": "156",
			"description": "Repnbl-Redes - Saída para beneficiário do regime"
		},
		{
			"code": "157",
			"description": "Recompe - Saída de matérias-primas e produtos intermediários para beneficiários do regime"
		},
		{
			"code": "158",
			"description": "Recompe - Saída de matérias-primas e produtos intermediários destinados a industrialização de equipamentos - Program a Estímulo Universidade-Empresa - Apoio à Inovação"
		},
		{
			"code": "159",
			"description": "Produtos nacionais, duráveis, uso e consumo dos eventos"
		},
		{
			"code": "160",
			"description": "Regime Especial de Admissão Temporária nos Termos do Art. 2o da IN 1361/2013"
		},
		{
			"code": "161",
			"description": "Regime Especial de Admissão Temporária nos termos do art. 5o da IN 1361/2013"
		},
		{
			"code": "162",
			"description": "Regime Especial de Admissão Temporária nos termos do art. 7o da IN 1361/2013(Suspensão com pagamento de tributos diferidos até a duração do regime, limitado a 100%do valor original)"
		},
		{
			"code": "163",
			"description": "REPETRO-Industrialização Venda no mercado interno de matérias-primas, produtos intermediários e materiais de embalagem para serem utilizados integralmente no processo de industrialização de produto final destinado às atividades de exploração, de desenvolvimento e de produção de petróleo, de gás natural e de outros hidrocarbonetos fluidos à PJ habilitada no Repetro-Industrialização. - Instrução Normativa RFB nº 1901, de 17 de julho de 2019."
		},
		{
			"code": "164",
			"description": "REPETRO-SPED Venda dos produtos finais destinados às atividades de exploração, de desenvolvimento e de produção de petróleo, de gás natural e de outros hidrocarbonetos fluidos previstas na Lei nº 9.478, de 6 de agosto de 1997, na Lei nº 12.276, de 30 de junho de 2010, e na Lei nº 12.351, de 22 de dezembro de 2010, por fabricantes desses, beneficiários do Repetro-Industrialização, quando diretamente adquiridos por pessoa jurídica habilitada no Repetro-Sped.- Instrução Normativa RFB nº 1901, de 17 de julho de 2019."
		},
		{
			"code": "165",
			"description": "O transportador com relação aos produtos tributados que transportar desacompanhados da documentação comprobatória de sua procedência; qualquer possuidor - com relação aos produtos tributados cuja posse mantiver para fins de venda ou industrialização; o industrial ou equiparado, mediante requerimento, nas operações anteriores, concomitantes ou posteriores às saídas que promover, nas hipóteses e condições estabelecidas pela Secretaria da Receita Federal, nos termos da IN RFB nº 1.081/2010."
		},
		{
			"code": "",
			"description": ""
		}
	],
	"isencao": [
		{
			"code": "301",
			"description": "Produtos industrializados por instituições de educação ou de assistência social, destinados auso próprio ou a distribuição gratuita a seus educandos ou assistidos"
		},
		{
			"code": "302",
			"description": "Produtos industrializados por estabelecimentos públicos e autárquicos da União, dos Estados, do Distrito Federal e dos Municípios, não destinados a comércio"
		},
		{
			"code": "303",
			"description": "Amostras de produtos para distribuição gratuita, de diminuto ou nenhum valor comercial"
		},
		{
			"code": "304",
			"description": "Amostras de tecidos sem valor comercial"
		},
		{
			"code": "305",
			"description": "Pés isolados de calçados"
		},
		{
			"code": "306",
			"description": "Aeronaves de uso militar e suas partes e peças, vendidas à União"
		},
		{
			"code": "308",
			"description": "Papel destinado à impressão de músicas"
		},
		{
			"code": "309",
			"description": "Panelas e outros artefatos semelhantes, de uso doméstico, de fabricação rústica, de pedra ou barro bruto"
		},
		{
			"code": "310",
			"description": "Chapéus, roupas e proteção, de couro, próprios para tropeiros"
		},
		{
			"code": "311",
			"description": "Material bélico, de uso privativo das Forças Armadas, vendido à União"
		},
		{
			"code": "312",
			"description": "Automóvel adquirido diretamente a fabricante nacional, pelas missões diplomáticas e repartições consulares de caráter permanente, ou seus integrantes, bem assim pelas representações internacionais ou regionais de que o Brasil seja membro, e seus funcionários,peritos, técnicos e consultores, de nacionalidade estrangeira, que exerçam funções de caráter permanente"
		},
		{
			"code": "313",
			"description": "Veículo de fabricação nacional adquirido por funcionário das missões diplomáticas acreditadas junto ao Governo Brasileiro"
		},
		{
			"code": "314",
			"description": "Produtos nacionais saídos diretamente para Lojas Francas"
		},
		{
			"code": "315",
			"description": "Materiais e equipamentos destinados a Itaipu Binacional"
		},
		{
			"code": "316",
			"description": "Produtos Importados por missões diplomáticas, consulados ou organismo internacional"
		},
		{
			"code": "317",
			"description": "Bagagem de passageiros desembaraçada com isenção do II."
		},
		{
			"code": "318",
			"description": "Bagagem de passageiros desembaraçada com pagamento do II."
		},
		{
			"code": "319",
			"description": "Remessas postais internacionais sujeitas a tributação simplificada."
		},
		{
			"code": "320",
			"description": "Máquinas e outros destinados à pesquisa científica e tecnológica"
		},
		{
			"code": "321",
			"description": "Produtos de procedência estrangeira, isentos do II"
		},
		{
			"code": "322",
			"description": "Produtos de procedência estrangeira utilizados em eventos esportivos"
		},
		{
			"code": "323",
			"description": "Veículos automotores, máquinas, equipamentos, bem assim suas partes e peças separadas, destinadas à utilização nas atividades dos Corpos de Bombeiros"
		},
		{
			"code": "324",
			"description": "Produtos importados para consumo em congressos, feiras e exposições"
		},
		{
			"code": "325",
			"description": "Bens de informática, Matéria Prima, produtos intermediários e embalagem destinados a Urnas eletrônicas - TSE"
		},
		{
			"code": "326",
			"description": "Materiais, equipamentos, máquinas, aparelhos e instrumentos, bem assim os respectivos acessórios, sobressalentes e ferramentas, que os acompanhem, destinados à construção do Gasoduto Brasil - Bolívia"
		},
		{
			"code": "327",
			"description": "Partes, peças e componentes, adquiridos por estaleiros navais brasileiros, destinados ao emprego na conservação, modernização, conversão ou reparo de embarcações registradas no Registro Especial Brasileiro - REB"
		},
		{
			"code": "328",
			"description": "Aparelhos transmissores e receptores de radiotelefonia e radiotelegrafia; veículos para patrulhamento policial; armas e munições, destinados a órgãos de segurança pública da União, dos Estados e do Distrito Federal"
		},
		{
			"code": "329",
			"description": "Automóveis de passageiros de fabricação nacional destinados à utilização como táxi adquiridos por motoristas profissionais"
		},
		{
			"code": "330",
			"description": "Automóveis de passageiros de fabricação nacional destinados à utilização como táxi por impedidos de exercer atividade por destruição, furto ou roubo do veículo adquiridos por motoristas profissionais."
		},
		{
			"code": "331",
			"description": "Automóveis de passageiros de fabricação nacional destinados à utilização como táxi adquiridos por cooperativas de trabalho."
		},
		{
			"code": "332",
			"description": "Automóveis de passageiros de fabricação nacional destinados a pessoas portadoras de deficiência física, visual, mental severa ou profunda, ou autistas"
		},
		{
			"code": "333",
			"description": "Produtos estrangeiros, recebidos em doação de representações diplomáticas estrangeiras sediadas no País, vendidos em feiras, bazares e eventos semelhantes por entidades beneficentes"
		},
		{
			"code": "334",
			"description": "Produtos industrializados na Zona Franca de Manaus - ZFM, destinados ao seu consumo interno"
		},
		{
			"code": "335",
			"description": "Produtos industrializados na ZFM, por estabelecimentos com projetos aprovados pela SUFRAMA, destinados a comercialização em qualquer outro ponto do Território Nacional"
		},
		{
			"code": "336",
			"description": "Produtos nacionais destinados à entrada na ZFM, para seu consumo interno, utilização ou industrialização, ou ainda, para serem remetidos, por intermédio de seus entrepostos, à Amazônia Ocidental"
		},
		{
			"code": "337",
			"description": "Produtos industrializados por estabelecimentos com projetos aprovados pela SUFRAMA, consumidos ou utilizados na Amazônia Ocidental, ou adquiridos através da ZFM ou de seus entrepostos na referida região"
		},
		{
			"code": "338",
			"description": "Produtos de procedência estrangeira, relacionados na legislação, oriundos da ZFM e que derem entrada na Amazônia Ocidental para ali serem consumidos ou utilizados:"
		},
		{
			"code": "339",
			"description": "Produtos elaborados com matérias-primas agrícolas e extrativas vegetais de produção regional, por estabelecimentos industriais localizados na Amazônia Ocidental, com projetos aprovados pela SUFRAM A"
		},
		{
			"code": "340",
			"description": "Produtos industrializados em Área de Livre Comércio"
		},
		{
			"code": "341",
			"description": "Produtos nacionais ou nacionalizados, destinados à entrada na Área de Livre Comércio de Tabatinga - ALCT"
		},
		{
			"code": "342",
			"description": "Produtos nacionais ou nacionalizados, destinados à entrada na Área de Livre Comércio de Guaiará-Mirim - ALCGM"
		},
		{
			"code": "343",
			"description": "Produtos nacionais ou nacionalizados, destinados à entrada nas Áreas de Livre Comércio de Boa Vista - ALCBV e Bonfim - ALCB"
		},
		{
			"code": "344",
			"description": "Produtos nacionais ou nacionalizados, destinados à entrada na Área de Livre Comércio de Macapá e Santana - ALCMS"
		},
		{
			"code": "345",
			"description": "Produtos nacionais ou nacionalizados, destinados à entrada nas Áreas de Livre Comércio de Brasiléia - ALCB e de Cruzeiro do Sul - ALCCS"
		},
		{
			"code": "346",
			"description": "Recompe - equipamentos de informática - de beneficiário do regime para escolas das redes públicas de ensino federal, estadual, distrital, municipal ou nas escolas sem fins lucrativos de atendimento a pessoas com deficiência"
		},
		{
			"code": "347",
			"description": "Importação de materiais para os jogos (medalhas, troféus, impressos, bens não duráveis, etc.) "
		},
		{
			"code": "348",
			"description": "Suspensão convertida em Isenção"
		},
		{
			"code": "349",
			"description": "Empresas vinculadas ao CIO"
		},
		{
			"code": "350",
			"description": "Saída de produtos importados pelo RIO 2016"
		},
		{
			"code": "351",
			"description": "Produtos nacionais, não duráveis, uso e consumo dos eventos, adquiridos pelas pessoas jurídicas mencionadas no § 2o do art. 4o da Lei n° 12.780/2013"
		}
	],
	"outros": [
		{
			"code": "601",
			"description": "Equipamentos e outros destinados à pesquisa e ao desenvolvimento tecnológic"
		},
		{
			"code": "602",
			"description": "Equipamentos e outros destinados à empresas habilitadas no PDTI e PDTA utilizados em pesquisa e ao desenvolvimento tecnológico"
		},
		{
			"code": "603",
			"description": "Microcomputadores e outros de até R$11.000,00, unidades de disco, circuitos, etc, destinados a bens de informática ou automação. Centro-Oeste SUDAM SUDENE"
		},
		{
			"code": "604",
			"description": "Microcomputadores e outros de até R$11.000,00, unidades de disco, circuitos, etc, destinados a bens de informática ou automação."
		},
		{
			"code": "605",
			"description": "Bens de informática não incluídos no art. 142 do Decreto 7.212/2010 - Produzidos no Centro-Oeste, SUDAM, SUDENE"
		},
		{
			"code": "606",
			"description": "Bens de informática não incluídos no art. 142 do Decreto 7.212/2010"
		},
		{
			"code": "607",
			"description": "Padis"
		},
		{
			"code": "608",
			"description": "Patvd"
		},
		{
			"code": "999",
			"description": "Tributação normal IPI; Outros;"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/fiscal/taxes/ipi/table.json
// module id = 1537
// module chunks = 0